@if (this.show) {
  <cam-badge [type]="this.getType()" [value]="this.getTranslate() | translate"></cam-badge>
}
